module.exports = __webpack_public_path__ + "static/media/signal.0de046fc.svg";